import CardWithRoles from "components/card/CardWithRoles";
import accessControlImage from "../public-api/icons/public-api-access-control.svg";

export default function AccessGrantsCard() {
  return (
    <CardWithRoles
      name="API - Access Grants"
      image={accessControlImage}
      description="Allow Siemens services to use your company's data (e.g., your rates) when processing requests. Not all services need this - only those that work with your specific business information."
      targetRoles={["Sales", "Admin"]}
      link={`/api/access-grants`}
      testid="public-api-access-grants"
    />
  );
}
